{
  "appName": "Facility Locator",
  "entryFile": "./facility-locator-entry.jsx",
  "entryName": "facilities",
  "rootUrl": "/find-locations",
  "productId": "0f27f045-978f-4139-b7b9-e48f94f1d70e"
}
